import gql from 'graphql-tag'

export const SUBSCRIBE_ROUTES = gql`
    subscription($orgId:uuid!) {
        Routes: Routes(where: {organizationId: {_eq: $orgId}}, order_by: {updated_at: desc}){
            id
            name
            organizationId
            driverId
            vehicleId
            created_at
            updated_at
            Driver{
                id
                name
            }
            Vehicle{
                id
                name
                platNo
            }
            RouteShops{
                id
                sequence
                Organization{
                    id
                    name
                }
            }
        }
    }`

export const GET_ROUTE_BY_ID = gql`
    subscription ($id:uuid!){
        Routes: Routes(where: {id: {_eq: $id}}){
            id
            name
            organizationId
            driverId
            vehicleId
            created_at
            updated_at
            Driver{
                id
                name
            }
            Vehicle{
                id
                name
                platNo
            }
            RouteShops{
                id
                sequence
                Organization{
                    id
                    name
                }
            }
        }
    }`
